<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="!toggle.checked || viewType === 'table'"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip()"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <ng-container *ngIf="toggle.checked && viewType !== 'table'">
    <div class="row">
      <div class="col-md-6 d-flex gap-3">
        <button class="btn btn-secondary-info" (click)="onEditDocument()">
          <i class="cs-icon cs-icon-pdf text-lg"></i> Document
        </button>
        <button class="btn btn-secondary-danger" (click)="info.onDelete()" *ngIf="deletable">
          <i class="cs-icon cs-icon-trash"></i>
          Delete
        </button>
      </div>
    </div>
  </ng-container>
</div>

<app-autopilot-automation-info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [class.d-none]="viewType !== 'table'"
  #info
>
  <ng-container actions>
    <button
      class="btn btn-light-info btn-sm"
      (click)="onEditDocument()"
      i18n-matTooltip
      matTooltip="Document Template"
      *ngIf="automationGroup"
    >
      <i class="cs-icon cs-icon-pdf text-lg"></i>
    </button>
  </ng-container>
</app-autopilot-automation-info>
